import { reskinStyles } from 'core/components/theme/theme-variant';
import { makeStyles } from '@material-ui/core/styles';
import { THEME_VARIANTS } from 'core/components/theme/theme-variant';
import arrowMatchUrl from './arrow-matches.svg';

const useStyles = makeStyles((theme) => ({
  customerLink: {
    fontSize: 16,
    color: theme.colorPalette.green_90
  },
  matchCustomer: {
    background: theme.colorPalette.beige_25,
    padding: '8px 20px 7px 5px',
    borderRadius: '3px 3px 3px 3px',
    boxShadow: '0 2px 2px 0 rgba(0, 0, 0, 0.24), 0 0 2px 0 rgba(0, 0, 0, 0.12)',
    right: '7%',
    ...reskinStyles(theme, theme.cardStyles.inset)
  },
  potentialMatches: {
    backgroundImage: `url("${arrowMatchUrl}")`,
    width: 320,
    height: 57,
    objectFit: 'contain',
    borderRadius: theme.sizes.roundCorners,
    padding: '8px 0 8px 24px',
    // Reskin: an outlined card instead of the arrow-shaped background.
    ...(theme.themeVariant === THEME_VARIANTS.RESKIN && {
      ...theme.cardStyles.outlined,
      backgroundImage: 'none',
      height: 'auto',
      padding: theme.spacing(3, 4),
      '& $matchLabel': {
        color: theme.colorPalette.green_100
      },
      '& $matchAction': theme.actionStyles.link
    })
  },
  noMatchOffer: {
    background: 'transparent',
    borderRadius: '3px 3px 3px 3px',
    borderStyle: 'solid',
    borderColor: theme.colorPalette.white
  },
  matchLabel: {
    whiteSpace: 'pre'
  },
  matchAction: {
    color: theme.colorPalette.white,
    fontSize: 12
  },
  matchAction2: {
    color: theme.colors.action_text,
    fontSize: 12,
    ...reskinStyles(theme, theme.actionStyles.link)
  },
  subtitle: {
    paddingRight: 10
  },
  subtitleOrange: {
    paddingRight: 10,
    color: theme.colorPalette.orange_50
  },
  hover: {
    cursor: 'pointer'
  },
  noPotentialMatches: {
    background: 'transparent',
    padding: theme.spacing(5),
    marginRight: theme.spacing(5),
    borderRadius: '3px 3px 3px 3px',
    borderStyle: 'solid',
    borderColor: theme.colorPalette.white
  },
  copyButton: {
    padding: 0,
    marginLeft: theme.spacing(1),
    marginBottom: theme.spacing(1),
    borderRadius: '50%'
  },
  simulatedSourceBadge: {
    '&&': {
      maxWidth: 'none',
      backgroundColor: theme.colorPalette.beige_25,
      color: theme.colorPalette.beige_90,
      ...reskinStyles(theme, theme.labelStyles.outlined)
    }
  },
  titleLink: {
    font: 'inherit',
    color: 'inherit',
    textDecoration: 'underline',
    textUnderlineOffset: 4
  }
}));

export default useStyles;
